module.exports = __webpack_public_path__ + "images/sort-up-down-hover-red-053d526c.svg";